import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { IHknrAccount } from '../types/hknr-account.type';

export interface HknrAccountInitialState extends BaseDataReducerV2InitialState<any> {
  account: IHknrAccount | null;
}

const { initialState, AC, reducer } = basedDataReducerV2<any, HknrAccountInitialState>('hknr-account');

const hknrInitialState: HknrAccountInitialState = {
  ...initialState,
  account: null,
};

export const hknrAccount = createSlice({
  name: 'hknrAccount',
  initialState: hknrInitialState,
  reducers: {
    setHknrAccount: (state, action: PayloadAction<IHknrAccount | null>) => {
      state.account = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as HknrAccountInitialState, action);
    });
  },
});
export const HknrAccountAC = AC;

export const { setHknrAccount } = hknrAccount.actions;
